<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <profile />

      <a class="navbar-brand"
        >{{ $store.state.user.phone }}
        <span @click="$modal.show('profile')" class="badge badge-info mr-2">
          <span class="ti-pencil"></span
        ></span>
        <span v-if="$store.state.business"
          >{{ $store.state.business.title }}
        </span>
        <span v-else>ROOT</span>
        <span v-if="routeName"> | {{ routeName }}</span>
      </a>
      <div class="flex ai-center" v-if="seasons && seasons.length">
        <!-- <div class="m-x-2 fw-6 ws-nowrap">
          Учебный сезон
        </div>
        <multiselect 
          style="min-width: 200px;"
          class="m-r-4"
          v-model="seasonId" 
          :options="seasons" 
          track-by="id" 
          label="id"
          :searchable="false" 
          :close-on-select="true" 
          :show-labels="false"
        >
        <template v-slot:singleLabel="{ option }">
          <strong>{{ option.title }}</strong>
        </template>
        </multiselect> -->
        
        <div class="m-x-2 fw-6">
          Учебный сезон
        </div>
        <div class="m-r-4" style="min-width: 200px;">
          <select v-model="seasonId" @change="changeSeason" class="form-control">
            <option v-for="(option, key) in seasons" :key="key" 
              :value="option.id" 
              :class="{'is_default': option.is_default}">
              {{ option.title }}
            </option>
          </select>
        </div>
      </div>

      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
    </div>
  </nav>
</template>
<script>
import { mapState } from "vuex";
import Profile from "../../components/Profile.vue";
import Multiselect from 'vue-multiselect'
export default {
  components: { Profile, Multiselect },
  computed: {
    routeName() {
      const { path } = this.$route;
      for (let i = 0; i < this.routes.length; i++) {
        if ("/" + this.routes[i].path === path) {
          return this.capitalizeFirstLetter(this.routes[i].title);
          break;
        }
      }
    },
    ...mapState(["routes", "seasons"]),
  },
  watch:{
    seasons(p){
      if(p && p.length){
        // this.seasonId = p.filter(e=>{return e.is_default})[0].id
        this.seasonId = localStorage.getItem("seasonId")
      }
    }
  },
  created(){

  },
  data() {
    return {
      value: '',
      options: ['Select option', 'options', 'selected', 'multiple', 'label', 'searchable', 'clearOnSelect', 'hideSelected', 'maxHeight', 'allowEmpty', 'showLabels', 'onChange', 'touched'],
      seasonId: null,
      activeNotifications: false,
    };
  },
  methods: {
    changeSeason(){
      localStorage.setItem("seasonId", this.seasonId);
      this.$http.defaults.headers.common["season-id"] = this.seasonId;
      location.reload();
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
<style lang="scss">
  option{
    &.is_default{
      background-color: #ebeba3;
    }
  }
</style>
